import { JSX } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from '@greystar/ui';
import { PageSection } from '@greystar/designsystem';

const PDPCalculatorStructure = (props: ComponentProps): JSX.Element => (
  <div>
    <PageSection isFlushed>
      <Placeholder
        name={`pdp-calculator-top-${props.params.DynamicPlaceholderId}`}
        rendering={props.rendering}
      />
    </PageSection>
    <div>
      <Placeholder
        name={`pdp-calculator-middle-${props.params.DynamicPlaceholderId}`}
        rendering={props.rendering}
      />
    </div>

    <Placeholder
      name={`pdp-calculator-bottom-${props.params.DynamicPlaceholderId}`}
      rendering={props.rendering}
    />
  </div>
);

export default PDPCalculatorStructure;
